import React from "react";
import { useTranslation } from "react-i18next";
import structurePhoto from "../../img/about/structure-photo.jpg";

function Structure() {
  const { t } = useTranslation();

  return (
    <section className="mt">
      <div className="glcontainer flex flex-col xl:flex-row xl:items-center gap-[30px] xl:gap-[103px]">

        {/* Photo */}
        <div className="w-full xl:w-[600px] h-[240px] xl:h-[443px] rounded-[20px] overflow-hidden shrink-0">
          <img src={structurePhoto} alt="" className="w-full h-full object-cover -scale-x-100" />
        </div>

        {/* Text */}
        <div className="flex flex-col gap-[20px] xl:gap-[60px] xl:w-[517px]">
          <div className="flex flex-col">
            <span className="font-['Montserrat'] font-black text-[16px] xl:text-[20px] text-[#0a0a0a] tracking-[-0.92px] uppercase leading-none">
              {t("about.structure.subtitle")}
            </span>
            <h2 className="font-['Montserrat'] font-black text-[24px] xl:text-[46px] text-[#0a0a0a] tracking-[-0.92px] uppercase leading-none">
              {t("about.structure.title")}
            </h2>
          </div>
          <p className="font-['Inter'] font-normal text-[14px] xl:text-[18px] text-[#717171] leading-[1.4]">
            {t("about.structure.desc")}
          </p>
        </div>

      </div>
    </section>
  );
}

export default Structure;
